import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { EvchargeTelemetryService } from '../../lib/services/evcharge-telemetry.service';
import {
  requestSystemEvchargeEnergyAggregation,
  updateSystemEvchargeEnergyAggregation,
  setSystemEvchargeEnergyAggregationError,
} from '../actions/block.actions';
import { AppState, getEmsConfig } from '..';

@Injectable()
export class EvchargeEnergyAggregationEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<AppState>,
    private readonly evchargeTelemetryService: EvchargeTelemetryService
  ) {}

  requestEvchargeEnergyAggregation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(requestSystemEvchargeEnergyAggregation),
      withLatestFrom(this.store),
      switchMap(([{ systemId, instanceId, deviceId, period, date }, {systemState}]) => {
        const system = systemState.systemList[systemId];
        if (!system) {
          throw new Error(`System with id ${systemId} not found`);
        }

        const emsConfig = getEmsConfig(system);

        if( !deviceId || !emsConfig ) {
          console.warn('❌ EVCharge V2 Effect: Device ID and EMS ID are required');
          return of(setSystemEvchargeEnergyAggregationError({
            systemId,
            instanceId,
            deviceId: deviceId || '',
            period,
            error: 'Device ID and EMS ID are required'
          }));
        }

        const aggregationMethod = period === 'month'
          ? this.evchargeTelemetryService.getEvChargeMonthlyAggregation(systemId, deviceId, date, emsConfig.type, emsConfig.loggerId)
          : this.evchargeTelemetryService.getEvChargeYearlyAggregation(systemId, deviceId, date, emsConfig.type, emsConfig.loggerId);

        return aggregationMethod.pipe(
          map(aggregationData =>
            updateSystemEvchargeEnergyAggregation({
              systemId,
              instanceId,
              deviceId,
              period,
              aggregationData
            })
          ),
          catchError(error =>
            of(setSystemEvchargeEnergyAggregationError({
              systemId,
              instanceId,
              deviceId,
              period,
              error: error?.message || 'Failed to fetch energy aggregation'
            }))
          )
        );
      })
    )
  );
}
